/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Button_AnalyzeInputs */

const en_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const de_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const fr_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const es_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const it_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const nl_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const pl_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const fi_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const da_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

const sv_keyword_optimizer_button_analyze = /** @type {(inputs: Keyword_Optimizer_Button_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze Keywords`)
};

/**
* | output |
* | --- |
* | "Analyze Keywords" |
*
* @param {Keyword_Optimizer_Button_AnalyzeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_analyze = /** @type {((inputs?: Keyword_Optimizer_Button_AnalyzeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_AnalyzeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_analyze(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_analyze(inputs)
	if (locale === "es") return es_keyword_optimizer_button_analyze(inputs)
	if (locale === "it") return it_keyword_optimizer_button_analyze(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_analyze(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_analyze(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_analyze(inputs)
	if (locale === "da") return da_keyword_optimizer_button_analyze(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_analyze(inputs)
	return en_keyword_optimizer_button_analyze(inputs)
});